export default __webpack_public_path__ + "static/sc-nonpro-72cd51c96f42e4e82aae195190bc7412.webp";